import script from "./CommissionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommissionModal.vue?vue&type=script&lang=ts&setup=true"

import "./CommissionModal.vue?vue&type=style&index=0&id=0fc7a2be&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc7a2be"]])

export default __exports__